import React, { useState, useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Home from "../home";
import AllAwakens from "./allAwakens";
import Sidebar from "../sidebar";
import Createnew from "./createnew";
import FactFinderClients from "./factFinderClients";
import Settings from "../settings";
import Profile from "../profile";
import Renewal from "../renewal";
import AwakenTables from "../reusableComponents/AwakenTables";
import Reports from "../reports";
import adminAuthService from "../../services/authService";

export default function Dashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null = checking, true/false = result

  // Initialize auth service and check authentication once
  useEffect(() => {
    adminAuthService.initializeAuth();
    setIsAuthenticated(adminAuthService.isAuthenticated());
  }, []);

  // Close sidebar on mobile by default
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };

    handleResize(); // Set initial state
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Show nothing while checking authentication
  if (isAuthenticated === null) {
    return null; // or a loading spinner
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="w-full flex">
      <div className="h-full flex">
        <Sidebar sideBar={sidebarOpen} setSideBar={setSidebarOpen} />
      </div>
      <div
        className={`w-full transition-all duration-300 ${
          sidebarOpen ? "ml-80 md:ml-64" : "ml-0"
        }`}
      >
        <Routes>
          <Route path="dashboard" element={<Home />} />
          <Route path="awaken-tables" element={<AwakenTables />} />
          <Route path="settings" element={<Settings />} />
          <Route path="fact-finder-clients" element={<FactFinderClients />} />
          <Route path="profile" element={<Profile />} />
          <Route path="renewal" element={<Renewal />} />
          <Route path="reports" element={<Reports />} />
          <Route path="*" element={<AllAwakens />} />
          {/* <Route path="all-awakens" element={<AllAwakens />} /> */}
          <Route path="create-new" element={<Createnew />} />
        </Routes>
      </div>
    </div>
  );
}

// import React from "react";
// import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
// import Home from "../home";
// import AllAwakens from "./allAwakens";
// // import Zero2One from "../zero-to-one/zero-to-one";
// import Sidebar from "../sidebar";
// import Createnew from "../dashboard/createnew";

// export default function Dashboard() {
//   const Navigate = useNavigate();
//   return (
//     <div className="w-full flex ">
//       <div className="h-full flex">
//         <Sidebar />
//       </div>
//       <div className="w-full">
//         <Routes>
//           {/* Define all the routes relative to /dashboard */}
//           {localStorage.getItem("user") ? (
//             <>
//               <Route path="dashboard" element={<Home />} />
//               <Route path="" element={<AllAwakens />} />
//               <Route path="all-awakens" element={<AllAwakens />} />
//               <Route path="create-new" element={<Createnew />} />
//             </>
//           ) : (
//             Navigate("/login")
//           )}
//         </Routes>
//       </div>
//     </div>
//   );
// }
